import React from 'react';
import { MessageSquare, ClipboardCheck, FileSearch, ThumbsUp } from 'lucide-react';

const steps = [
  {
    number: "01",
    icon: MessageSquare,
    title: "Hubungi Kami",
    description: "Isi borang 3 maklumat atau terus WhatsApp untuk semakan awal percuma.",
    time: "2 minit"
  },
  {
    number: "02",
    icon: ClipboardCheck,
    title: "Sesi Konsultasi",
    description: "Consultant kami akan hubungi anda melalui WhatsApp untuk konsultasi peribadi.",
    time: "Hari yang sama"
  },
  {
    number: "03",
    icon: FileSearch,
    title: "Analisa Kewangan",
    description: "Kami analisa situasi anda dan tunjukkan pilihan terbaik mengikut kemampuan.",
    time: "1-2 hari"
  },
  {
    number: "04",
    icon: ThumbsUp,
    title: "Selesai!",
    description: "Komitmen anda lebih teratur, kewangan lebih lega.",
    time: "Proses pantas"
  }
];

const HowItWorks = () => {
  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-emerald-900 mb-3">
              Bagaimana Ia Berfungsi?
            </h2>
            <p className="text-emerald-700 text-sm sm:text-base">
              4 langkah mudah untuk susun semula kewangan anda
            </p>
          </div>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 relative">
            {/* Connection Line (Desktop only) */}
            <div className="hidden lg:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 z-0"></div>

            {steps.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <div
                  key={index}
                  className="relative bg-white border-2 border-emerald-100 rounded-2xl p-6 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 z-10"
                >
                  {/* Step Number */}
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <div className="bg-gradient-to-br from-amber-400 to-amber-600 text-emerald-950 font-bold text-sm px-4 py-1.5 rounded-full shadow-lg">
                      STEP {step.number}
                    </div>
                  </div>

                  {/* Icon */}
                  <div className="flex justify-center mb-4 mt-4">
                    <div className="bg-emerald-50 p-4 rounded-full border-2 border-emerald-100">
                      <IconComponent className="h-8 w-8 text-emerald-700" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-lg sm:text-xl font-bold text-emerald-900 text-center mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-emerald-700 text-center mb-4 leading-relaxed">
                    {step.description}
                  </p>

                  {/* Time Badge */}
                  <div className="text-center">
                    <span className="inline-block px-3 py-1 bg-amber-50 text-amber-700 text-xs font-semibold rounded-full border border-amber-200">
                      ⏱️ {step.time}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-10 sm:mt-12">
            <p className="text-emerald-800 text-base sm:text-lg font-semibold">
              💡 Total masa: <span className="text-amber-600">Anda mungkin selesai dalam beberapa hari sahaja!</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
